
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  Agency.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\Agency.ts

import {Address } from "./Address";
import {ApeCod } from "./ApeCod";
export class Agency {

  // int Id
  public Id: number=0;

  // byte IsHeadQuarter
  public IsHeadQuarter: number=0;

  // string Acronym
  public Acronym?: string=null;

  // string Designation
  public Designation?: string=null;

  // int? AddressId
  public AddressId?: number=null;

  // string Siret
  public Siret?: string=null;

  // string Rsa
  public Rsa?: string=null;

  // string Duns
  public Duns?: string=null;

  // string WebSite
  public WebSite?: string=null;

  // int? ApeId
  public ApeId?: number=null;

  // int? HeadQuarterId
  public HeadQuarterId?: number=null;

  // string TvaIntra
  public TvaIntra?: string=null;

  // Address Address
  public Address: Address=null;

  // ApeCod ApeCod
  public ApeCod: ApeCod=null;
}